var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"navigation-link",class:_vm.icon,attrs:{"exact":_vm.exact,"id":_vm.id,"params":_vm.params,"to":_vm.to}},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.notificationCount)?_c('span',{staticClass:"notification"},[_vm._v(_vm._s(_vm.notificationCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }